import { useEffect, useRef, useState } from "react";

export function useDynamicSplash(isLoading, options = {}) {
  const {
    delayMs = 160,
    minVisibleMs = 180,
  } = options;

  const [showSplash, setShowSplash] = useState(false);
  const shownAtRef = useRef(null);
  const delayTimerRef = useRef(null);
  const hideTimerRef = useRef(null);

  useEffect(() => {
    if (!isLoading) return;

    if (hideTimerRef.current) {
      clearTimeout(hideTimerRef.current);
      hideTimerRef.current = null;
    }

    if (showSplash) return;

    if (delayTimerRef.current) {
      clearTimeout(delayTimerRef.current);
    }

    delayTimerRef.current = setTimeout(() => {
      shownAtRef.current = Date.now();
      setShowSplash(true);
    }, delayMs);

    return () => {
      if (delayTimerRef.current) {
        clearTimeout(delayTimerRef.current);
        delayTimerRef.current = null;
      }
    };
  }, [isLoading, delayMs, showSplash]);

  useEffect(() => {
    if (isLoading) return;

    if (delayTimerRef.current) {
      clearTimeout(delayTimerRef.current);
      delayTimerRef.current = null;
    }

    if (!showSplash) {
      return;
    }

    const shownAt = shownAtRef.current || Date.now();
    const elapsed = Date.now() - shownAt;
    const remaining = Math.max(minVisibleMs - elapsed, 0);

    hideTimerRef.current = setTimeout(() => {
      shownAtRef.current = null;
      setShowSplash(false);
    }, remaining);

    return () => {
      if (hideTimerRef.current) {
        clearTimeout(hideTimerRef.current);
        hideTimerRef.current = null;
      }
    };
  }, [isLoading, showSplash, minVisibleMs]);

  useEffect(() => {
    return () => {
      if (delayTimerRef.current) clearTimeout(delayTimerRef.current);
      if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
    };
  }, []);

  return showSplash;
}
